import React from "react";

import { Props } from "./types";
import { DateTimeInput } from "./dateTimeInput";

function Week(props: Props) {
  return (
    <DateTimeInput
      date={props.week[0]}
      input={(dateTime) => props.editDate(dateTime)}
      week={props.week}
      prev={props.prev}
      next={props.next}
    />
  );
}

export { Week };
